import { MEASUREMENT_BASE_URL } from '~/constants';

export const KEEP_OLD_UI_STORAGE_KEY = 'measurement-keep-old-ui';
export const KEEP_OLD_UI_QUERY_PARAM = 'keep-old-ui';

type RedirectRule = {
  pattern: RegExp;
  getPath: (campaignId?: string) => string;
};

const REDIRECT_RULES: RedirectRule[] = [
  {
    pattern: /^\/impact-measurement\/admin\/campaign\/([^/]+)\/mapping\/?$/,
    getPath: campaignId => `/id-mapping/${campaignId}`
  },
  {
    pattern: /^\/impact-measurement\/admin\/campaign\/([^/]+)\/tracking\/?$/,
    getPath: campaignId => `/media-tracking/${campaignId}`
  },
  {
    pattern: /^\/impact-measurement\/admin\/campaign\/([^/]+)\/details\/?$/,
    getPath: campaignId => `/study-manager/${campaignId}?stepId=details`
  },
  {
    pattern: /^\/impact-measurement\/admin\/campaign\/([^/]+)\/review\/?$/,
    getPath: campaignId => `/study-manager/${campaignId}?stepId=review`
  },
  {
    pattern: /^\/impact-measurement\/admin\/campaign\/([^/]+)\/?$/,
    getPath: campaignId => `/studies/${campaignId}`
  },
  {
    pattern: /^\/impact-measurement\/report\/([^/]+)\/?$/,
    getPath: campaignId => `/studies/${campaignId}`
  },
  {
    pattern: /^\/impact-measurement\/admin\/campaigns\/?$/,
    getPath: () => '/studies'
  },
  {
    pattern: /^\/impact-measurement\/admin\/accounts\/?$/,
    getPath: () => '/accounts'
  },
  {
    pattern: /^\/impact-measurement\/admin\/account\/(?!new\/?$)([^/]+)\/?$/,
    getPath: accountId => `/accounts/${accountId}`
  },
  {
    pattern: /^\/impact-measurement\/admin\/users\/?$/,
    getPath: () => '/users'
  },
  {
    pattern: /^\/impact-measurement\/admin\/user\/(?!new\/?$)([^/]+)\/?$/,
    getPath: userId => `/users/${userId}`
  },
  {
    pattern: /^\/impact-measurement\/?$/,
    getPath: () => '/studies'
  },
  {
    pattern: /^\/?$/,
    getPath: () => '/studies'
  }
];

export const shouldKeepOldUi = (): boolean => {
  return localStorage.getItem(KEEP_OLD_UI_STORAGE_KEY) === 'true';
};

export const storeKeepOldUiPreference = (): void => {
  localStorage.setItem(KEEP_OLD_UI_STORAGE_KEY, 'true');
};

export const handleKeepOldUiQueryParam = (
  search: string = window.location.search
): boolean => {
  const params = new URLSearchParams(search);

  if (params.get(KEEP_OLD_UI_QUERY_PARAM) !== 'true') {
    return false;
  }

  storeKeepOldUiPreference();

  params.delete(KEEP_OLD_UI_QUERY_PARAM);
  const nextSearch = params.toString();
  const nextUrl = `${window.location.pathname}${
    nextSearch ? `?${nextSearch}` : ''
  }${window.location.hash}`;

  window.history.replaceState(null, '', nextUrl);

  return true;
};

export const buildMeasurementRedirectUrl = (
  targetPath: string,
  audienceURL: string = window.location.href,
  baseUrl: string = MEASUREMENT_BASE_URL
): string => {
  const redirectUrl = new URL(targetPath, baseUrl);

  redirectUrl.searchParams.set('welcome', 'true');
  redirectUrl.searchParams.set('audienceURL', audienceURL);

  return redirectUrl.toString();
};

export const getMeasurementRedirectUrl = (
  pathname: string = window.location.pathname,
  audienceURL: string = window.location.href,
  baseUrl: string = MEASUREMENT_BASE_URL
): string | null => {
  for (const rule of REDIRECT_RULES) {
    const match = pathname.match(rule.pattern);

    if (!match) {
      continue;
    }

    const campaignId = match[1];
    const targetPath = rule.getPath(campaignId);

    return buildMeasurementRedirectUrl(targetPath, audienceURL, baseUrl);
  }

  return null;
};
